// Modules
import axios from 'axios'
import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'
// CSS
import '_Asset/css/Admin/Page/login.css'
// API
import { MemLoginApi, MemSfrtLoginApi, MemSessionApi, MemUseApi, MemLoginUseApi } from '_Route/Api'
// Component
import { setInfoAcc, setLoggedAcc } from 'Modules/authority'
import SignInWithSeyfert from 'Admin/Component/SignInWithSeyfert'


const AdLogin = () => {

  // Use Hooks
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const isLoginAcc = useSelector(state => state.loggedAcc) // 회원 로그인 상태

  const authHost = process.env.REACT_APP_AUTH_HOST

  const [info, setInfo] = useState({
    email: '',
    pass: '',
  })
  const { email, pass } = info;

  const onChange = (e) => {
    const { name, value } = e.target;
    setInfo({...info, [name]: value});
  }


  /*========================================================================
  * LOG-IN Function
  ========================================================================*/
  // Session ID 발급
  const getSessionID = (userUID) => {
    axios({
      url: MemSessionApi,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': userUID,
      }
    })
    .then(res => {
      // console.log(res, "GET Member Session ID Success!")
      const result = res.data.result;
      
      dispatch(setLoggedAcc(true))
      localStorage.setItem('memSessionID', result[result.length - 1].session_id)

      navigate('/admin/dashboard')
    })
    .catch(err => {
      console.error(err, "GET Member Session ID Error...")
    })
  }

  // 일반 관리자 로그인
  // const basicLogin = () => {
  //   if (email === '') {
  //     alert("이메일을 입력해주세요.")
  //   }
  //   else if (pass === '') {
  //     alert("비밀번호를 입력해주세요.")
  //   } else {
  //     axios({
  //       url: MemLoginApi,
  //       method: 'POST',
  //       data: info
  //     })
  //     .then(res => {
  //       // console.log(res,"Member Basic Login Success!")
  //       const r = res.data;
  //       if(r.loggedIn){
  //         dispatch(setLoggedAcc(true))
  //         dispatch(setInfoAcc({ // 로그인된 회원 정보 설정
  //           dPcompany: r.decoded.company,
  //           dPemail: r.decoded.email,
  //           dPip: r.decoded.ip,
  //           dPname: r.decoded.name,
  //           dPpn: r.decoded.phone_number,
  //           dProles: r.decoded.roles,
  //           dPuid: r.decoded.uid,
  //           dPaccess_score: r.decoded.access_score,
  //         }));
  //         getSessionID(r.decoded.uid)
  //         localStorage.setItem('memLoginKey', 'default')
  //         localStorage.setItem('memSessionTime', r.sessionTime * 60)
  //       }
  //     })
  //     .catch(err => {
  //       // console.error("Login ERROR...", err);
  //       alert(err.response.data.message);
  //     })
  //   }
  // }
  
  // Seyfert 인증센터 로그아웃
  const seyfertLogout = () => {
    axios.defaults.withCredentials = true;
    axios({
      url: `${authHost}/logout`,
      method: 'POST'
    })
    .then(res => {
      // console.log(res, "Seyfert 인증센터 Logout Success!")
      dispatch(setLoggedAcc(false))
      localStorage.clear()
    })
    .catch(err => {
      console.log(err, "Seyfert 인증센터 Logout Error...")
    })
  }

  // 미사용 회원 계정 사용 처리 요청
  const UpdateACC = (accUuid) => {
    axios({
      url: MemLoginUseApi,
      method: 'PUT',
      data: {
        uid: accUuid,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      seyfertLogout()
      alert('회원 사용 여부 변경 요청을 완료하였습니다.')
    })
    .catch(err => {
      console.error("PUT Member Use Error...", err);
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }

  // Seyfert 인증센터 로그인
  /* TOKEN: 서버로 전달할 토큰 (서버에서 비밀번호 대신 토큰 검증을 하게됨)
     decodeJWT: token정보. 주로 서버에서 사용. */
  const sfrtLogin = (TOKEN, decodeJWT) => {
    // console.log(decodeJWT,"decodeJWT")
    axios({
      url: MemSfrtLoginApi,
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${TOKEN}`, // Bearer type으로 Access Token 전송
      }
    })
    .then(res => {
      // console.log(res, "Seyfert Login Success!")
      const r = res.data;
      if(r.loggedIn) {
        dispatch(setInfoAcc({ // 로그인된 회원 정보 설정
          dPcompany: r['decoded.company'],
          dPemail: r['decoded.email'],
          dPip: r['decoded.ip'],
          dPis_allow_ip: r['decoded.is_allow_ip'],
          dPis_allow_access_time: r['decoded.is_allow_access_time'],
          dPip: r['decoded.ip'],
          dPname: r['decoded.name'],
          dPphone_number: r['decoded.phone_number'],
          dProles: r['decoded.roles'],
          dProles_num: r['roles_num'],
          dPuid: r['decoded.uid'],
          dPaccess_score: r['decoded.access_score'],
          // dPaccess_score: 300,
          dPmaster: r['master'],
        }));
        getSessionID(r['decoded.uid'])
        localStorage.setItem('memLoginKey', 'JWT')
        localStorage.setItem('memSessionTime', r.sessionTime * 60)
      }
      else if (!r.loggedIn && r.acc_use === 'N') {
        if(window.confirm("현재 미사용 처리된 계정입니다.\n계정 활성화를 요청하시겠습니까?")) {
          UpdateACC(r['decoded.uid'])
        }
      }
    })
    .catch(err => {
      console.error(err, "Seyfert Login ERROR...")

      if (err.response.data.message) {
        seyfertLogout()
        alert(err.response.data.message)
      }
    })
  }

  useEffect(() => {
    if (isLoginAcc) {
      navigate('/admin/dashboard')
    }
  }, [location])
  // console.log(isLoginAcc,"login 상태")
  

  return (
    <div className="adLogin">
      <div className="inner">
        <div className="logoGroup">
          <img src={require('_Asset/img/seyfert_logo.svg').default} alt="Seyfert" />
          <h2>Developers</h2>
        </div>
        
         {/* [2023.01.17] 개발자 포탈 로그인 주석 처리 */}
        {/* <fieldset>
          <legend>Login</legend>

         
          <div className="fieldGroup">
            <div className="field">
              <span className='icofont-key-hole'></span>
              <input type="email" className="input lg line" name="email" onChange={(e) => onChange(e)} placeholder="Email" autoFocus={true} />
            </div>

            <div className="field">
              <span className='icofont-key'></span>
              <input type="password" className="input lg line" name="pass" onChange={(e) => onChange(e)} placeholder="Password" maxLength="20" onKeyUp={(e) => e.key === 'Enter' && basicLogin()} />
            </div>
          </div>
        </fieldset> */}

        <div className="btnArea">
          {/* <button type="button" className='btn sfrtBlue md round_10' onClick={basicLogin}>LOGIN</button> */}
          <SignInWithSeyfert onResult={({idToken, decodeJWT}) => {
            sfrtLogin(idToken, decodeJWT)
          }} />
        </div>
      </div>

      <Link to="/"><i className="icofont-rounded-left" /> <span>홈으로 돌아가기</span> </Link>
    </div>
  )
}

export default AdLogin;